import React, { useState, useEffect } from 'react';
import ProductListRow from './row';
import Pagination from "../Pagination/Pagination";
import { InternalLink } from '../form-elements/Link';
//import { serializeSearchParams } from '../../helpers/url';

function ProductList({ products = []}) {
    const [articles, setArticles] = useState(products)
    
    const [page, setPages] = useState(1);  
    const handlePage = (page) => {
        setPages(page)
    }
    const articlesPerPage =  50;

    useEffect(() => {
        setArticles(products.slice((page-1) * articlesPerPage, (page) * articlesPerPage))
    }, [page, products])    

    if (!products.length) return null;

    return (
        <div className="uk-grid uk-grid-small uk-child-width-1-1@m" data-uk-grid="">
            {articles.map(product => (
                <div key={product.id}>
                    <ProductListRow product={product} />
                </div>
            ))}
        <div className="uk-flex uk-flex-center uk-flex-middle">
            <div>*inkl. MwSt., zzgl. etwaiger&nbsp;</div>
            <InternalLink to="/versandkosten" modifier="text" hideArrow className="">
                Versandkosten
            </InternalLink>
        </div>

        {
        products.length > articlesPerPage && 
        <div>
            <Pagination
                itemCount={products.length}
                itemsPerPage={articlesPerPage}
                selectedPage={page}               
                onPageChange={page => {
                    window.scrollTo(0, 0);
                    handlePage(page);
                }}
            />
        </div>
        }
        </div>
    );
}

export default ProductList;
